import {
  CHANGE_SEARCH,
  UPDATE_REALTY_OFFERS_SECONDARY,
  UPDATE_INPUT_INTERVALS_SECONDARY,
  CLEAR_FILTERS_SECONDARY,
  SET_LAUNCHING_YEARS_SECONDARY,
  UPDATE_REQUEST_STATUS_SECONDARY,
  UPDATE_PAYLOAD_REQUEST,
  CLOSE_INFOWINDOWS_SECONDARY,
  SET_INFOWINDOWS_SECONDARY,
  UPDATE_BUILDING_DATA_SECONDARY,
  UPDATE_CHARTS_DATA_SECONDARY,
} from './offersSecondary.actions';

const realtyOffersFiltersOptions = {
  launchingYears: [],
  constructionPattern: [],
  adTypes: [
    { name: 'Venda', id: 'sale' },
    { name: 'Locação', id: 'rent' },
  ],
  realtyTypes: [
    { name: 'Apartamento', id: 'ap' },
    { name: 'Casa', id: 'cs' },
    { name: 'Comercial', id: 'comm' },
  ],
  timeframe: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  privateAreaInterval: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  valueInterval: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  bedrooms: [
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  suites: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  garages: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    {
      name: '2',
      selected: false,
    },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  unitPrice: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  realtyAge: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  status: '',
  buildings: '',
  companies: '',
};

const initialFiltersSecondary = {
  adType: 'sale',
  realtyType: { name: 'Apartamento', id: 'ap' },
  inputIntervals: {
    timeframe: { min: '', max: '' },
    privateAreaInterval: { min: '', max: '' },
    pricePerSquareMt: { min: '', max: '' },
    unitPrice: { min: '', max: '' },
    realtyAge: { min: '', max: '' },
  },
  bedrooms: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  suites: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  garages: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
};

const initialFiltersPrimary = {
  realtyType: { name: 'Apartamento', id: 'ap' },
  inputIntervals: {
    timeframe: { min: '', max: '' },
    privateAreaInterval: { min: '', max: '' },
    pricePerSquareMt: { min: '', max: '' },
    unitPrice: { min: '', max: '' },
  },
  bedrooms: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  suites: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  garages: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    {
      name: '2',
      selected: false,
    },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  selectedConstructionPattern: [],
  selectedStatus: [],
  selectedBuildings: [],
  selectedCompanies: [],
};

const initialState = {
  realtyOffersFiltersOptions,
  realtyOffersSecondary: initialFiltersSecondary,
  displayBigNumbersSecondaryCharts: false,
  displaySecondaryCharts: false,
  newAlertName: '',
  isActive: {
    sidebar: true,
    menuAction: '',
    mapAction: '',
    results: false,
  },
  userInput: {
    building: '',
    company: '',
  },
  payloadRequest: {},
  requestStatusSecondary: {
    // INACTIVE | LOADING | LOADED | FAILED
    realtyAnnouncedByPeriod: 'INACTIVE',
    announcedOverExisting: 'INACTIVE',
    adsPerExistingRealties: 'INACTIVE',
  },
  infoWindowsSecondary: [],
  chartsDataSecondary: {
    price_variation_by_period: [],
    realty_announced_by_period_mean: [],
    ads_per_existing_realties: [],
    ads_per_existing_realties_mean: [],
    realty_announced_by_period: [],
    average_realty_announced_by_period: [],
    average_realties_announced_over_existing_realties: [],
  },
};

// TODO:
// REMOVER TUDO QUE NÃO FOR REFERENTE AO MERCADO SECUNDÁRIO

export default function offersSecondaryReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case CHANGE_SEARCH:
      return {
        ...state,
        userInput: { ...state.userInput, [payload.name]: payload.value },
      };

    case UPDATE_REALTY_OFFERS_SECONDARY:
      return {
        ...state,
        realtyOffersSecondary: {
          ...state.realtyOffersSecondary,
          [payload.name]: payload.value,
        },
      };

    case UPDATE_INPUT_INTERVALS_SECONDARY:
      return {
        ...state,
        realtyOffersSecondary: {
          ...state.realtyOffersSecondary,
          inputIntervals: {
            ...state.realtyOffersSecondary.inputIntervals,
            [payload.name]: payload.value,
          },
        },
      };

    case CLEAR_FILTERS_SECONDARY:
      return {
        ...state,
        realtyOffersSecondary: {
          ...initialFiltersSecondary,
          inputIntervals: {
            timeframe: { min: '', max: '' },
            privateAreaInterval: { min: '', max: '' },
            pricePerSquareMt: { min: '', max: '' },
            unitPrice: { min: '', max: '' },
            realtyAge: { min: '', max: '' },
          },
        },
      };

    case SET_LAUNCHING_YEARS_SECONDARY:
      return {
        ...state,
        realtyOffersFiltersOptions: {
          ...state.realtyOffersFiltersOptions,
          launchingYears: payload,
        },
      };

    case UPDATE_REQUEST_STATUS_SECONDARY:
      return {
        ...state,
        requestStatusSecondary: {
          ...state.requestStatusSecondary,
          [payload.name]: payload.value,
        },
      };

    case UPDATE_BUILDING_DATA_SECONDARY:
      return { ...state, buildingData: { ...state.buildingData, ...payload } };
    case UPDATE_PAYLOAD_REQUEST:
      return { ...state, payloadRequest: payload };

    case SET_INFOWINDOWS_SECONDARY:
      return { ...state, infoWindowsSecondary: [payload] };

    case CLOSE_INFOWINDOWS_SECONDARY:
      state.infoWindowsSecondary?.forEach((iw) => iw.close());
      return state;
    case UPDATE_CHARTS_DATA_SECONDARY:
      return {
        ...state,
        chartsDataSecondary: {
          ...state.chartsDataSecondary,
          [payload.name]: payload.value,
        },
      };

    default:
      return state;
  }
}
